import React from "react";
import Header from "../components/Header";
import VerifyEmailSection from "../sections/authentication/VerifyEmailSection";

function VerifyEmailPage() {
  return (
    <div className={ClassName.container}>
      <Header />
      <VerifyEmailSection />
    </div>
  );
}

export default VerifyEmailPage;

const ClassName = {
  container: "flex flex-col text-black relative font-main",
};
